var _circle, _path, _mask, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrackResultDetailIcon = function SvgTrackResultDetailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E3E9FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0075FF",
    stroke: "#0075FF",
    d: "M11.5 7.5h1v1h-1z"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "track-result-detail-icon_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10h3v5h1v2h-3v-5h-1v-2Z"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 10h3v5h1v2h-3v-5h-1v-2Z",
    fill: "#0075FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 10h2V8h-2v2Zm-3 0V8H8v2h2Zm3 5h-2v2h2v-2Zm1 0h2v-2h-2v2Zm0 2v2h2v-2h-2Zm-3 0H9v2h2v-2Zm0-5h2v-2h-2v2Zm-1 0H8v2h2v-2Zm3-4h-3v4h3V8Zm2 4v-2h-4v2h4Zm0 3v-3h-4v3h4Zm-2 2h1v-4h-1v4Zm-1-2v2h4v-2h-4Zm2 0h-3v4h3v-4Zm-1 2v-2H9v2h4Zm-4-5v3h4v-3H9Zm1 2h1v-4h-1v4Zm-2-4v2h4v-2H8Z",
    fill: "#0075FF",
    mask: "url(#track-result-detail-icon_svg__a)"
  })));
};
export default SvgTrackResultDetailIcon;